import { useEffect, useRef } from "react";

export function useAnimation(isPlaying: boolean, setImageIndex: (fn: (prev: number) => number) => void, totalImages: number, intervalMs = 600) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (isPlaying && totalImages > 0) {
      console.log(`Starting animation with ${totalImages} images, interval: ${intervalMs}ms`);
      intervalRef.current = setInterval(() => {
        setImageIndex(prev => {
          const nextIndex = (prev + 1) % totalImages;
          console.log(`Animation: ${prev} -> ${nextIndex} (total: ${totalImages})`);
          return nextIndex;
        });
      }, intervalMs);
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isPlaying, setImageIndex, totalImages, intervalMs]);
} 